export default "__VITE_ASSET__ZxrB5kZX__"